// Bulk member selection for pathway assignment on the tracking dashboard.
// Responsibilities: live count, soft 20-selection cap, and "Continuer" navigation.
// Selection truth lives in the DOM (checkboxes only); this module owns NO state.

var BULK_SELECTION_CAP = 20; // soft cap — raise or remove freely

function bulkSelectedValues() {
  var checks = document.querySelectorAll('input[name="member_ids[]"]:checked');
  var values = Array.prototype.map.call(checks, function (el) { return el.value; });
  return Array.from(new Set(values));
}

function updateBulkCount() {
  var countEl = document.getElementById('bulk-count-text');
  if (!countEl) return;
  var count = bulkSelectedValues().length;
  var template = count === 0 ? countEl.dataset.zero
    : (count === 1 ? countEl.dataset.one : countEl.dataset.other);
  countEl.textContent = template.replace('%{count}', count);
}

function enforceBulkCap() {
  var checks = document.querySelectorAll('input.bulk-member-check');
  var checkedCount = bulkSelectedValues().length;
  var notice = document.getElementById('bulk-cap-notice');
  checks.forEach(function (el) {
    if (!el.checked) el.disabled = checkedCount >= BULK_SELECTION_CAP;
  });
  if (notice) notice.classList.toggle('d-none', checkedCount < BULK_SELECTION_CAP);
}

function updateBulkContinueState() {
  var btn = document.getElementById('bulk-continue-btn');
  if (!btn) return;
  btn.disabled = bulkSelectedValues().length === 0;
}

function updateBulkUi() {
  enforceBulkCap();
  updateBulkCount();
  updateBulkContinueState();
}

function initBulkContinue() {
  var btn = document.getElementById('bulk-continue-btn');
  if (!btn) return;
  btn.addEventListener('click', function () {
    var values = bulkSelectedValues();
    if (values.length === 0) return;
    var params = values.map(function (v) { return 'member_ids[]=' + encodeURIComponent(v); }).join('&');
    window.location = btn.dataset.newUrl + '?' + params;
  });
}

function initBulkSelectHandlers() {
  var members = document.querySelector('.members-card');
  if (!members || members.dataset.bulkSelectBound) return;

  members.dataset.bulkSelectBound = 'true';
  members.addEventListener('change', function (e) {
    if (!e.target.classList.contains('bulk-member-check')) return;

    document.querySelectorAll('input.bulk-member-check').forEach(function (check) {
      if (check.value === e.target.value) check.checked = e.target.checked;
    });
    updateBulkUi();
  });
}

function initTrackingBulkSelect() {
  if (!document.getElementById('bulk-action-bar')) return;
  updateBulkUi();
  initBulkContinue();
  initBulkSelectHandlers();
}

function focusActionResults(frame) {
  var targetId = frame.dataset.trackingScrollTarget;
  if (!targetId) return;

  delete frame.dataset.trackingScrollTarget;
  var target = frame.querySelector('#' + targetId);
  if (!target) return;

  window.requestAnimationFrame(function () {
    target.scrollIntoView({
      behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth',
      block: 'start'
    });
    target.focus({ preventScroll: true });
  });
}

document.addEventListener('click', function (e) {
  var action = e.target.closest('[data-tracking-scroll-target]');
  if (!action) return;

  var frame = document.getElementById('tracking-dashboard');
  if (frame) frame.dataset.trackingScrollTarget = action.dataset.trackingScrollTarget;
});

document.addEventListener('turbo:load', initTrackingBulkSelect);
document.addEventListener('turbo:frame-load', function (e) {
  if (e.target.id !== 'tracking-dashboard') return;

  initTrackingBulkSelect();
  focusActionResults(e.target);
});
